<template>
  <el-dialog title="退货" :visible="visible" :close-on-click-modal="false" width="1180px" @close="handleCancel">
    <template slot="title">
      <div>
        <span class="el-dialog__title">退货</span>
        <el-popover style="margin-left: 25px" placement="bottom" trigger="click" ref="popover">
          <el-input
            type="textarea"
            v-model="analyseContent"
            :placeholder="
              simpleAnalyse
                ? '请输入退货内容，示例：\n张三\nHH1234 1\nHH1234*10'
                : '请输入退货的内容，示例：\n张三\nHH1234 红色 38\nHH1234 黑色 39*1 40*2'
            "
            :autosize="{ minRows: 10 }"
          ></el-input>
          <el-switch v-model="simpleAnalyse" active-text="简洁版" style="float: left; margin-top: 15px" />
          <el-button type="primary" :loading="analyseLoading" style="float: right; margin-top: 10px" @click="handleAnalyse">提交</el-button>
          <el-button type="primary" slot="reference">一键退货</el-button>
        </el-popover>
        <el-input
          v-model="scanBarcode"
          ref="scanInput"
          placeholder="扫码/手动输入条码"
          style="width: 200px; margin-left: 15px"
          clearable
          :disabled="!form.PurchaserName"
          @keydown.enter.native="handleScanBarcode"
        ></el-input>
        <span style="color: red; font-size: 12px; margin-left: 15px">
          <i class="el-icon-warning-outline" style="margin-right: 4px"></i>
          提示：扫码前请切换英文输入法，否则条码无法正常识别
        </span>
      </div>
    </template>
    <el-form ref="editForm" :model="form" :inline="true" label-position="right" class="editForm" style="padding-right: 0px">
      <el-form-item prop="PurchaserName" label="客户：">
        <el-tooltip effect="dark" :content="PurchaserNameQQ" :disabled="PurchaserNameQQ == ''" placement="bottom">
          <el-autocomplete
            :disabled="purchaser != null"
            v-model="PurchaserNameQQ"
            value-key="PurchaserName"
            :fetch-suggestions="querySearch"
            @select="handleSeletedPurchaser($event)"
            style="width: 150px"
            @change="handleMatchPurchaser"
          ></el-autocomplete>
        </el-tooltip>
      </el-form-item>
      <el-form-item prop="ReceivePayment" label="实退金额：">
        <el-input :disabled="purchaser != null" v-model="form.ReceivePayment" style="width: 120px"></el-input>
      </el-form-item>
      <el-form-item v-if="$store.state.routes.systemSetting.MultiWarehouse" label="仓库：">
        <warehouse-select :value.sync="form.WID" select_style="width:115px;"></warehouse-select>
      </el-form-item>
      <el-form-item v-if="$store.state.routes.systemSetting.MultiStore" label="档口：">
        <store-select :value.sync="form.StoreID" :set_default="true" select_style="width:115px;"></store-select>
      </el-form-item>
      <el-form-item style="float: right; margin-right: 0px" v-show="purchaser == null" label="退货时间：">
        <span class="time">{{ time }} </span>
        <el-radio-group @input="changeTime" v-model="timeType">
          <el-radio :label="0">现在</el-radio>
          <el-radio :label="1">昨天</el-radio>
          <el-radio :label="2">
            <el-date-picker
              :disabled="timeType != 2"
              v-model="form.CreateTime"
              :clearable="false"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              style="width: 130px"
            >
            </el-date-picker>
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <el-table ref="gridTable" :data="tableData" class="refundTable" border height="350">
      <el-table-column prop="ItemNo" label="货号" header-align="center" align="center" width="150">
        <template slot-scope="{ row, $index }">
          <el-autocomplete
            :ref="`itemno_${$index}`"
            :placeholder="form.PurchaserName != '' ? '请输入货号' : '请先选择客户'"
            :disabled="form.PurchaserName == ''"
            v-model="row.ItemNo"
            :trigger-on-focus="false"
            value-key="ItemNo"
            :fetch-suggestions="querySearchItemNo"
            @change="handleMatchItemNo(row, $index)"
            @select="handleSeletedItemNo(row, $index, $event)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="SpecName" label="规格" header-align="center" align="center">
        <template slot-scope="{ row, $index }">
          {{ row.SpecName }}
          <span v-if="row.ProductID > 0" class="el-icon-edit-outline hand" @click="showSpecDialog(row, $index)"></span>
        </template>
      </el-table-column>
      <el-table-column prop="Num" header-align="center" align="center" label="数量" width="155">
        <template slot-scope="{ row }">
          <el-input-number
            v-model.number="row.Num"
            :min="1"
            size="mini"
            :step="1"
            :precision="0"
            @change="handleInput($event, row)"
            @input="handleInput($event, row)"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="Price" header-align="center" align="center" label="商品价" width="100">
        <template slot-scope="{ row }">
          <el-input v-model="row.Price" v-format.float></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="SettlePrice" header-align="center" align="center" label="客户价" width="100">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.SettlePrice"
            :title="row.ProductID && row.SettlePrice != row.OriginSettlePrice ? '客户价存在变动' : ''"
            :class="row.ProductID && row.SettlePrice != row.OriginSettlePrice ? 'warn-tip' : ''"
            @input="handleInput($event, row)"
            v-format.float
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="Payment" header-align="center" align="center" label="金额" width="100">
        <template slot-scope="{ row }">
          {{ row.Payment | decimalFormat }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="$store.state.routes.systemSetting.ShowRefundSupplier"
        prop="Price"
        header-align="center"
        align="center"
        label="供应商"
        width="110"
      >
        <template slot-scope="{ row, $index }">
          <el-select placeholder="请选择供应商" v-model="row.SupplierID" @change="changeSupplier(row, $index)">
            <el-option
              v-for="subOption in row.suppliers || []"
              :key="subOption.SupplierID"
              :label="subOption.SupplierName"
              :value="subOption.SupplierID"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="校验客户报单记录">
        <el-table-column prop="TotalTakedNum" header-align="center" align="center" label="提货累计" />
        <el-table-column prop="TotalRefundNum" header-align="center" align="center" label="已退累计" />
        <el-table-column prop="TotalRemainNum" header-align="center" align="center" label="可退数量">
          <template slot-scope="{ row }">
            <span v-if="row.ProductID > 0 && row.TotalTakedNum < row.TotalRefundNum" style="color: red">0</span>
            <span v-else style="color: green">{{ row.ProductID > 0 ? row.TotalTakedNum - row.TotalRefundNum : '' }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column prop="" header-align="center" align="center" label="操作" width="80">
        <template slot-scope="{ row, $index }">
          <el-button type="danger" @click="handleRowClick(row, $index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <span style="position: absolute; left: 0; font-size: 18px">
        <span style="font-weight: bold">退货合计</span>： <span style="color: #f56c6c; padding: 0 5px">{{ form.RefundNum }} </span>双
        <span style="color: #f56c6c; padding: 0 5px">{{ form.RefundFee }} </span>元
      </span>
      <i class="el-icon-setting" @click="systemSettingDialogVisible = true" />
      <el-button type="default" @click="handleCancel">取消</el-button>
      <el-button type="danger" v-if="purchaser == null" :loading="saveLoading" @click="handleSave('credit')">欠款</el-button>
      <el-button type="warning" v-if="purchaser == null" :loading="saveLoading" @click="handleSave('cash')">已转现金</el-button>
      <el-button type="success" v-if="purchaser == null" :loading="saveLoading" @click="handleSave('wechat')">已转微信</el-button>
      <el-button type="primary" v-if="purchaser == null" :loading="saveLoading" @click="handleSave('alipay')">已转支付宝</el-button>
      <el-button type="primary" v-if="purchaser != null" :loading="saveLoading" @click="handleSave(null)">确定</el-button>
    </div>
    <el-dialog
      v-dialog-drag
      title="选择规格"
      width="400px"
      :visible="selectPropsDialogVisible"
      :close-on-click-modal="false"
      @close="selectPropsDialogVisible = false"
      append-to-body
    >
      <div v-if="SpecData.Colors.length > 0">
        <div class="div_prop_item">颜色：</div>
        <div
          :class="'div_prop_value' + (activeColor && activeColor.Value === item.Value ? ' current' : '')"
          @click="handleColorClick(item)"
          v-for="(item, index) in SpecData.Colors"
          :key="'color-' + index"
        >
          <div :title="item.Value">{{ item.Value }}</div>
        </div>
      </div>
      <div v-if="activeColor" class="mt-20">
        <div class="div_prop_item">尺码：</div>
        <el-button type="text" size="mini" @click="selectAllSizes" class="div_prop_value"> 全选 </el-button>
        <div
          :class="['div_prop_value', item.IsCheck ? ' current' : '']"
          @click="handleSizeClick(activeColor, item)"
          v-for="(item, index) in activeColor.Sizes"
          :key="'size-' + index"
        >
          <div :title="item.Value">{{ item.Value }}</div>
        </div>
      </div>
      <div v-else-if="SpecData.Colors.length > 0" class="mb-10">
        <div class="div_prop_item">尺码：</div>
        <div class="prop-list">
          <div class="div_prop_value disabled">请先选择颜色</div>
        </div>
      </div>
      <div style="margin: 10px 0; padding: 8px; background: #f5f5f5; border-radius: 4px"
        >已选： <br /><span v-html="selectedSpecsDisplay || '暂无选中规格'"></span
      ></div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="selectPropsDialogVisible = false">关闭</el-button>
        <el-button type="primary" size="small" @click="saveSelectPropsDialog">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-dialog-drag
      title="退货配置"
      width="325px"
      :visible="systemSettingDialogVisible"
      :close-on-click-modal="false"
      @close="systemSettingDialogVisible = false"
      append-to-body
    >
      <el-form label-width="100px" style="padding-right: 0px">
        <el-form-item label="退货允许时长">
          <el-select
            v-model="$store.state.routes.systemSetting.ReturnTimeLimit"
            @change="onSystemSettingSave({ ReturnTimeLimit: $store.state.routes.systemSetting.ReturnTimeLimit })"
          >
            <el-option :value="-1" label="不限" />
            <el-option :value="0.5" label="近15天" />
            <el-option :value="1" label="近1个月" />
            <el-option :value="2" label="近2个月" />
            <el-option :value="3" label="近3个月" />
            <el-option :value="6" label="近半年" />
            <el-option :value="12" label="近1年" />
          </el-select>
        </el-form-item>
        <el-form-item label="显示供应商">
          <el-switch
            v-model="$store.state.routes.systemSetting.ShowRefundSupplier"
            @change="onSystemSettingSave({ ShowRefundSupplier: $store.state.routes.systemSetting.ShowRefundSupplier })"
          />
        </el-form-item>
        <el-form-item v-if="purchaser == null" label="打印小票">
          <el-switch v-model="printConfig.bill.refundedAutoPrint" @change="$refs.printConfig1.saveConfig()" />
        </el-form-item>
        <el-form-item v-if="purchaser == null" label="打印条码">
          <el-switch v-model="printConfig.bill.autoPrintBarcode" @change="$refs.printConfig1.saveConfig()" />
        </el-form-item>
        <el-form-item v-if="$store.state.routes.systemSetting.WmsEnabled && purchaser == null" label="自动入库">
          <el-switch
            v-model="$store.state.routes.systemSetting.AutoRefund"
            @change="$store.dispatch('routes/changeSettingItem', { AutoRefund: $store.state.routes.systemSetting.AutoRefund })"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="systemSettingDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="请选择打印机打印商品条码"
      width="400px"
      :visible.sync="selectPrint"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      append-to-body
    >
      <div>
        <el-select v-model="curPrinter" placeholder="请选择" style="width: 350px">
          <el-option v-for="printer in printerList" :key="printer.value" :value="printer.label" :label="printer.label"></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="selectPrint = false">关闭</el-button>
        <el-button type="primary" size="small" @click="doPrint">开始打印</el-button>
      </div>
    </el-dialog>
    <div id="print-view-refund">
      <div class="print-view-main">
        <div class="paper-wrapper paper-bill"></div>
      </div>
      <trade-print
        ref="tradePrint1"
        print-view-tab="bill"
        :print-config.sync="printConfig"
        printViewID="#print-view-refund"
        print-source="cashier"
      ></trade-print>
      <stall-config
        v-show="false"
        ref="printConfig1"
        :field.sync="configField"
        :value.sync="printConfig"
        :level="0"
        source="cashier"
      ></stall-config>
    </div>
  </el-dialog>
</template>

<script>
import { submit, saveSystemSetting } from '@/api/base'
import { getDate } from '@/utils/tool'
import dayjs from 'dayjs'
import WarehouseSelect from '@/views/components/common/WarehouseSelect.vue'
import StoreSelect from '@/views/components/common/StoreSelect.vue'
import StallConfig from '@/views/stall/trade/components/StallConfig.vue'
import TradePrint from '@/views/stall/trade/components/TradePrint.vue'
import { getBarcodePrintConfig, doBarcodePrint } from '@/utils/barcodePrintHelper'
import { getPrinters } from '@/utils/lodopWrapper'

export default {
  name: 'AddRefund',
  components: {
    WarehouseSelect,
    StoreSelect,
    StallConfig,
    TradePrint,
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown)
  },
  data() {
    return {
      visible: false,
      tableData: [],
      searchItems: [],
      searchPurchases: [],
      purchaserProducts: {},
      timeType: 0,
      time: '',
      autoRefund: false,
      PurchaserNameQQ: '',
      configField: {},
      printConfig: { bill: {} },
      form: {
        CreateTime: '',
        TradeID: 0,
        PurchaserID: '',
        PurchaserName: '',
        RefundNum: 0,
        RefundFee: 0,
        ReceivePayment: 0,
        WID: 0,
        StoreID: 0,
      },
      data: null,
      timeout: null,
      purchaser: null,
      selectPropsDialogVisible: false,
      systemSettingDialogVisible: false,
      SpecData: { ItemNo: null, Specs: null, Colors: [], Sizes: [], Suppliers: [], SupplierID: '', SupplierName: '' },
      analyseLoading: false,
      analyseContent: '',
      simpleAnalyse: false,
      timeOut: null,
      selectedColors: [],
      activeColor: null,
      selectedSpecsDisplay: '',
      selectedProductID: 0,
      curRowIndex: -1,
      fromMatch: false,
      scanBarcode: '',
      scanLoading: false,
      // 条码打印 - 打印机选择
      hasInitPrinter: false, // 是否已初始化打印机列表
      selectPrint: false,
      curPrinter: '',
      printerList: [],
      pendingSpecList: [],
      pendingConfig: null,
      // 条码打印 - 进度状态
      printing: false,
      printPercent: 0,
      printStatus: '',
      printStatusText: '',
      saveLoading: false,
    }
  },
  methods: {
    handleKeyDown(event) {
      if (this.visible && event.key === 'ArrowDown') {
        const index = this.tableData.findIndex(item => !item.ProductID)
        if (index > -1) {
          const itemnoRef = this.$refs[`itemno_${index}`]
          if (itemnoRef) {
            itemnoRef.focus()
          }
        }
      }
      // 扫码枪通常以Enter结尾，如果在非扫码输入框区域检测到快速输入，提示定位并还原数据
      if (this.visible && event.key === 'Enter') {
        const scanInputEl = this.$refs.scanInput?.$el?.querySelector('input')
        if (document.activeElement !== scanInputEl) {
          // 检查焦点是否在表格区域内，还原被扫码枪污染的行数据
          const gridTable = this.$refs.gridTable?.$el
          if (gridTable && gridTable.contains(document.activeElement)) {
            for (let i = 0; i < this.tableData.length; i++) {
              const row = this.tableData[i]
              if (row.ProductID > 0 && row.OldItemNo && row.ItemNo !== row.OldItemNo) {
                row.ItemNo = row.OldItemNo
              }
              // 还原价格：从 suppliers 中找到匹配的数据
              if (row.ProductID > 0 && row.suppliers && row.SupplierID) {
                const matchedSupplier = row.suppliers.find(s => s.SupplierID === row.SupplierID)
                if (matchedSupplier && matchedSupplier.detailList && matchedSupplier.detailList.length > 0) {
                  const itemData = matchedSupplier.detailList[0]
                  row.SettlePrice = itemData.SettlePrice
                  row.OriginSettlePrice = itemData.SettlePrice
                  row.Price = itemData.Price
                  row.Cost = itemData.Cost
                  row.Payment = itemData.SettlePrice * (parseInt(row.Num) || 1)
                }
              }
            }
            this.getStatistics()
          }
          if (scanInputEl) {
            this.$baseMessage('扫码请定位到顶部输入框', 'warning')
          }
        }
      }
    },
    async handleScanBarcode() {
      if (!this.form.PurchaserName) {
        this.$baseMessage('请先选择客户', 'warning')
        return
      }
      const barcode = this.scanBarcode?.trim()
      if (!barcode) {
        this.$refs.scanInput?.$el?.querySelector('input')?.focus()
        return
      }
      if (this.scanLoading) return
      this.scanLoading = true
      try {
        const res = await submit(`/api/product/getProductSpecByBarcode?barcode=${encodeURIComponent(barcode)}`)
        if (!res.success) {
          this.$message.error(res.msg || '未识别到该条码')
          return
        }
        const spec = res.data
        // 检查是否已存在相同商品（同ProductID + 同SpecID）
        const existRow = this.tableData.find(row => row.ProductID == spec.ProductID && row.SpecID == spec.SpecID)
        if (existRow) {
          existRow.Num = (existRow.Num || 1) + 1
          existRow.Payment = parseInt(existRow.Num) * (parseFloat(existRow.SettlePrice) || 0)
          this.getStatistics()
          this.$message.success(`商品【${spec.ItemNo}】数量+1`)
        } else {
          // 用扫码获取到的ProductID调用getProductSelectDetail获取完整信息并新增行
          this.selectedProductID = spec.ProductID
          // 找到空行或新增一行
          let emptyIndex = this.tableData.findIndex(row => !row.ProductID)
          if (emptyIndex < 0) {
            this.addEmptyRow()
            emptyIndex = this.tableData.length - 1
          }
          this.curRowIndex = emptyIndex
          this.fromMatch = false
          // 先填入基本信息（颜色、尺码等规格信息）
          this.tableData[emptyIndex].ItemNo = spec.ItemNo
          this.tableData[emptyIndex].SpecName = spec.SpecName || `${spec.Color || ''}-${spec.Size || ''}`
          this.tableData[emptyIndex].scanColor = spec.Color || ''
          this.tableData[emptyIndex].scanSize = spec.Size || ''
          this.tableData[emptyIndex].scanSpecID = spec.SpecID || 0
          // 调用getProductSelectDetail获取完整供应商、价格等信息
          await this.getProductSelectDetail()
          this.$message.success(`已添加商品【${spec.ItemNo}】`)
        }
      } catch (e) {
        console.error('扫码异常', e)
      } finally {
        this.scanLoading = false
        this.scanBarcode = ''
        this.$nextTick(() => {
          this.$refs.scanInput?.$el?.querySelector('input')?.focus()
        })
      }
    },
    isColorSelected(color) {
      return this.selectedColors.some(item => item.Value === color.Value)
    },
    handleColorClick(color) {
      const isSelected = this.selectedColors.some(item => item.Value === color.Value)
      if (!isSelected) {
        const colorWithSizes = { ...color }
        colorWithSizes.Sizes = colorWithSizes.Sizes.map(size => ({ ...size, IsCheck: false }))
        this.selectedColors.push(colorWithSizes)
        this.activeColor = colorWithSizes
      } else {
        this.activeColor = this.selectedColors.find(item => item.Value === color.Value)
      }
      this.updateSelectedSpecsDisplay()
    },
    handleSizeClick(color, size) {
      if (!color || !size) return
      size.IsCheck = !size.IsCheck
      this.updateSelectedSpecsDisplay()
    },
    selectAllSizes() {
      if (!this.activeColor || !this.activeColor.Sizes.length) return
      const allChecked = this.activeColor.Sizes.every(size => size.IsCheck)
      this.activeColor.Sizes.forEach(size => {
        size.IsCheck = !allChecked
      })
      this.updateSelectedSpecsDisplay()
    },
    updateSelectedSpecsDisplay() {
      if (this.selectedColors.length === 0) {
        this.selectedSpecsDisplay = ''
        return
      }
      const displayArr = []
      this.selectedColors.forEach(color => {
        const selectedSizes = color.Sizes.filter(size => size.IsCheck)
          .map(size => size.Value)
          .join('，')

        if (selectedSizes) {
          displayArr.push(`${color.Value}：${selectedSizes}`)
        }
      })
      this.selectedSpecsDisplay = displayArr.join('<br>') || '暂无选中尺码'
    },
    async handleAnalyse() {
      if (this.analyseContent == '') {
        this.$message({ type: 'error', message: '退货的报单内容不能为空' })
        return
      }
      this.analyseLoading = true
      let content = this.analyseContent
      let contentList = content.split('\n')
      if (contentList[0] != this.form.PurchaserName) {
        var results = this.searchPurchases.filter(x => x.Name.toLowerCase() == contentList[0].toLowerCase())
        if (results.length > 0) {
          if (!this.form.PurchaserID) {
            this.form.PurchaserID = results[0].PurchaserID
            this.form.PurchaserName = results[0].Name
            this.PurchaserNameQQ = results[0].PurchaserName
          } else {
            contentList[0] = this.form.PurchaserName
            content = contentList.join('\n')
          }
        } else {
          content = this.form.PurchaserName + '\n' + content
        }
      }
      let res = await submit('/api/stallRefund/analyse', { Content: content, IsSimple: this.simpleAnalyse }).catch(error => {
        this.analyseLoading = false
      })
      this.analyseLoading = false
      if (res.data) {
        var list = this.tableData.filter(x => x.ProductID != 0)
        res.data.forEach(item => {
          if (list.some(x => x.ProductID == item.ProductID && x.SpecID == item.SpecID)) {
            for (let i = 0; i < list.length; i++) {
              if (list[i].ProductID == item.ProductID && list[i].SpecID == item.SpecID) {
                list[i] = item
                break
              }
            }
          } else {
            let suppliers = []
            item.SupplierNumList.forEach((supplierItem, supIndx) => {
              let detailList = []
              const supProItem = {
                ...item,
                OriginSettlePrice: item.SettlePrice,
                SupplierName: supplierItem.SupplierName,
                SupplierID: supplierItem.SupplierID,
                OldItemNo: item.ItemNo,
                TotalTakedNum: supplierItem.TotalSpecTakedNum,
                TotalRefundNum: supplierItem.TotalSpecRefundNum,
              }
              detailList.push(supProItem)
              let supItem = { SupplierID: supplierItem.SupplierID, SupplierName: supplierItem.SupplierName, detailList: detailList }
              suppliers.push(supItem)
              if (supIndx == 0) {
                item.SupplierID = supplierItem.SupplierID
                item.SupplierName = supplierItem.SupplierName
                item.TotalTakedNum = supplierItem.TotalTakedNum
                item.TotalRefundNum = supplierItem.TotalRefundNum
              }
            })
            item.suppliers = suppliers
            item.SupplierNumList = []
            list.push(item)
          }
        })
        list = list.sort(function (a, b) {
          if (a.ItemNo !== b.ItemNo) return a.ItemNo < b.ItemNo ? -1 : 1
          else if (a.SpecName !== b.SpecName) return a.SpecName < b.SpecName ? -1 : 1
        })
        this.tableData = list
        this.addEmptyRow()
      }
      if (res.msg) {
        this.$message({ type: 'error', message: res.msg })
        return
      }
      this.analyseContent = ''
      this.$refs.popover.doClose()
    },
    init(purchaser, tradeID, storeID) {
      var that = this
      that.time = dayjs().format('HH:mm:ss')
      that.timeType = 0
      that.changeTime()
      that.visible = true
      if (purchaser) {
        that.form.TradeID = tradeID
        that.purchaser = purchaser
        that.form.PurchaserID = purchaser.PurchaserID
        that.form.PurchaserName = purchaser.PurchaserName
        that.PurchaserNameQQ = purchaser.PurchaserName
      } else {
        that.purchaser = null
        that.form.TradeID = 0
        that.form.PurchaserID = ''
        that.form.PurchaserName = ''
        that.PurchaserNameQQ = ''
      }
      that.form.StoreID = typeof storeID != 'undefined' ? storeID : 0
      that.form.RefundNum = 0
      that.form.RefundFee = 0
      that.form.ReceivePayment = 0
      that.$nextTick(async () => {
        that.addEmptyRow()
        //if (!purchaser) {
        await that.loadPurchases()
        //}
        await that.$refs.printConfig1.getConfig()
        that.$refs.tradePrint1.init()
        that.$refs.scanInput?.$el?.querySelector('input')?.focus()
      })
    },
    changeTime() {
      switch (this.timeType) {
        case 0:
          this.form.CreateTime = getDate()
          break
        case 1:
          this.form.CreateTime = getDate(-1)
          break
      }
    },
    addEmptyRow() {
      this.tableData.push({
        ItemNo: '',
        SpecName: '',
        Num: 1,
        Price: 0,
        SettlePrice: 0,
        Payment: 0,
        SpecID: 0,
        ProductID: 0,
        SupplierID: '',
        SupplierName: '',
        Suppliers: [],
        Barcode: '',
      })
    },
    handleInput(e, row) {
      row.Payment = (parseInt(row.Num) || 0) * (parseFloat(row.SettlePrice) || 0)
      this.getStatistics()
    },
    getStatistics() {
      var total = 0
      let totalNum = 0
      if (this.tableData.length >= 0) {
        this.tableData.forEach(item => {
          if (item.ItemNo && item.SettlePrice) {
            totalNum += parseInt(item.Num) || 0
            total += (parseInt(item.Num) || 0) * (parseFloat(item.SettlePrice) || 0)
          }
        })
      }
      this.form.RefundFee = parseFloat(total.toFixed(2))
      this.form.RefundNum = totalNum
      this.form.ReceivePayment = total
    },
    handleRowClick(row, rowIndex) {
      if (this.tableData.length > 1) {
        var lastRow = this.tableData[rowIndex]
        if (lastRow.ItemNo == '') {
          return
        }
        this.tableData.splice(rowIndex, 1)
        this.getStatistics()
      }
    },
    async querySearch(queryString, callback) {
      if (this.purchaser == null) {
        var results = queryString
          ? this.searchPurchases.filter(x => {
              return x.Name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
            })
          : this.searchPurchases
        callback(results)
      }
    },
    async loadPurchases() {
      const { data } = await submit('/api/stall/getPurchaserList', {
        searchValue: '',
        ToPage: false,
      })
      data.forEach(d => {
        d.PurchaserName = d.Name + (d.QQ ? '(' + d.QQ + ')' : '')
      })
      this.searchPurchases = data
    },
    async handleSeletedPurchaser(selectedRow) {
      this.form.PurchaserID = selectedRow.PurchaserID
      this.form.PurchaserName = selectedRow.Name
      this.PurchaserNameQQ = selectedRow.PurchaserName
    },
    async handleMatchPurchaser() {
      if (this.PurchaserNameQQ.indexOf(this.form.PurchaserName) != 0) {
        this.form.PurchaserID = ''
        this.form.PurchaserName = this.PurchaserNameQQ
      }
    },
    async getProductSelectDetail() {
      let rowIndex = this.curRowIndex
      // 保留扫码时获取到的规格信息
      const scanRow = this.tableData[rowIndex]
      const scanColor = scanRow?.scanColor || ''
      const scanSize = scanRow?.scanSize || ''
      const scanSpecID = scanRow?.scanSpecID || 0
      const { data } = await submit('/api/stallRefund/getProductSelectDetail', {
        ProductID: this.selectedProductID,
        CheckStall: true,
        PurchaserID: this.form.PurchaserID,
      })
      if (data) {
        let isSelect = false
        for (var k = 0; k < data.Suppliers.length; k++) {
          let itemData = data.Suppliers[k].detailList[0]
          // 如果是扫码场景，尝试在detailList中找到匹配的规格
          let matchedItemData = itemData
          if (scanColor || scanSize) {
            const matched = data.Suppliers[k].detailList.find(d => scanColor && d.Color === scanColor && scanSize && d.Size === scanSize)
            if (matched) {
              matchedItemData = matched
            }
          }
          const item = {
            ...matchedItemData,
            Num: 1,
            OriginSettlePrice: matchedItemData.SettlePrice,
            Payment: matchedItemData.SettlePrice * 1,
            OldItemNo: matchedItemData.ItemNo,
            suppliers: data.Suppliers,
          }
          // 扫码时用条码匹配的规格信息覆盖SpecName和SpecID
          if (scanColor || scanSize) {
            item.SpecName = `${scanColor || item.Color || ''}-${scanSize || item.Size || ''}`
            item.SpecID = scanSpecID || item.SpecID || 0
            item.Color = scanColor || item.Color || ''
            item.Size = scanSize || item.Size || ''
          }
          if (
            !this.tableData.some(
              (x, idx) => idx != rowIndex && x.ProductID == item.ProductID && x.SpecID == item.SpecID && x.SupplierID == item.SupplierID
            )
          ) {
            isSelect = true
            this.tableData.splice(rowIndex, 1, item)
            break
          }
        }
        if (!isSelect) {
          if (this.fromMatch) {
            this.tableData.splice(rowIndex, 1)
          } else {
            this.tableData[rowIndex].ItemNo = this.tableData[rowIndex].OldItemNo
          }
        }
        this.getStatistics()
        this.$nextTick(() => {
          if (!this.tableData.some(x => x.ProductID == 0)) {
            this.addEmptyRow()
          }
        })
      }
    },
    async handleSeletedItemNo(row, rowIndex, selectedRow, fromMatch = false) {
      this.selectedProductID = selectedRow.ProductID
      this.curRowIndex = rowIndex
      this.fromMatch = fromMatch
      this.getProductSelectDetail()
    },
    async onSystemSettingSave(saveData) {
      await saveSystemSetting(saveData)
      if (this.tableData.length > 0) {
        let item = this.tableData[0]
        this.selectedProductID = item.ProductID
        this.curRowIndex = 0
        item.SpecID = 0
        item.SpecName = ''
        this.tableData = []
        this.tableData[0] = item
        if (item.ProductID > 0) {
          this.getProductSelectDetail()
        }
      }
    },
    changeSupplier(row, rowIndex) {
      let findData = this.tableData.find(
        (x, idx) => idx != rowIndex && x.ProductID == row.ProductID && x.SpecID == row.SpecID && x.SupplierID == row.SupplierID
      )
      if (findData != null) {
        this.$baseMessage('货号【' + row.ItemNo + '】已存在该供应商【' + findData.SupplierName + '】', 'error')
        row.SupplierID = ''
      } else {
        let itemData = row.suppliers.find(s => s.SupplierID == row.SupplierID).detailList[0]
        row.SpecID = 0
        row.SpecName = ''
        row.SupplierName = itemData.SupplierName
        row.Payment = itemData.SettlePrice * parseInt(row.Num)
        row.SettlePrice = itemData.SettlePrice
        row.OriginSettlePrice = itemData.SettlePrice
        row.Price = itemData.Price
        row.Cost = itemData.Cost
        row.TotalTakedNum = itemData.TotalTakedNum
        row.TotalRefundNum = itemData.TotalRefundNum
      }
    },
    handleMatchItemNo(row, rowIndex) {
      var that = this
      clearTimeout(that.timeOut)
      that.timeOut = setTimeout(() => {
        let selectedRow = that.searchItems.filter(i => i.ItemNo.toLowerCase() == row.ItemNo.toLowerCase())
        var productIdx = -1
        if (selectedRow.length > 0) {
          for (let i = 0; i < that.tableData.length; i++) {
            if (
              i != rowIndex &&
              that.tableData[i].ProductID == selectedRow[0].ProductID &&
              that.tableData[i].SpecID == selectedRow[0].SpecID
            ) {
              productIdx = i
              break
            }
          }
          if (productIdx < 0) {
            that.handleSeletedItemNo(row, rowIndex, selectedRow[0], true)
          } else {
            that.$baseMessage('已存在货号【' + row.ItemNo + '】的商品', 'error')
            if (that.tableData[rowIndex].ProductID <= 0) {
              that.tableData[rowIndex].ItemNo = ''
              that.tableData[rowIndex].Price = 0
              that.tableData[rowIndex].Cost = 0
              that.tableData[rowIndex].SettlePrice = 0
              that.tableData[rowIndex].Payment = 0
            } else {
              that.tableData[rowIndex].ItemNo = that.tableData[rowIndex].OldItemNo
            }
          }
        } else {
          if (that.tableData[rowIndex].ProductID > 0 && that.tableData[rowIndex].OldItemNo) {
            that.tableData[rowIndex].ItemNo = that.tableData[rowIndex].OldItemNo
          }
          if (that.tableData[rowIndex].ProductID <= 0) {
            that.tableData[rowIndex].ItemNo = ''
            that.tableData[rowIndex].Price = 0
            that.tableData[rowIndex].Cost = 0
            that.tableData[rowIndex].SettlePrice = 0
            that.tableData[rowIndex].Payment = 0
          }
        }
        if (!that.tableData.some(x => x.ProductID == 0)) {
          that.addEmptyRow()
        }
      }, 100)
    },
    async querySearchItemNo(query, callback) {
      if (!query) return callback([])
      clearTimeout(this.timeout)
      this.timeout = setTimeout(async () => {
        const { data } = await submit('/api/stallRefund/getProductSelectItemNo', {
          Keyword: query,
        })
        callback(data || [])
      }, 300)
    },
    //选择规格弹窗
    async showSpecDialog(row, rowIndex) {
      const { data, msg } = await submit('/api/stallRefund/getSpecs', {
        ItemNo: row.ItemNo,
        ProductID: row.ProductID,
        CheckStall: true,
        PurchaserID: this.form.PurchaserID,
        PurchaserName: this.form.PurchaserName,
        SupplierID: row.SupplierID,
      })
      if (msg != null && msg != '') {
        this.$baseMessage(msg)
        return
      }
      const buildColorSizeData = supplierSpecs => {
        const colorMap = {}
        supplierSpecs.forEach(spec => {
          const colorKey = spec.Color || '默认颜色'
          if (!colorMap[colorKey]) {
            colorMap[colorKey] = {
              Value: colorKey,
              Sizes: [],
            }
            const sizeSet = new Set()
            supplierSpecs.filter(s => s.Color === colorKey).forEach(s => sizeSet.add(s.Size || '均码'))
            colorMap[colorKey].Sizes = Array.from(sizeSet).map(size => ({
              Value: size,
              IsCheck: false,
            }))
          }
        })
        return Object.values(colorMap)
      }
      if (data.Suppliers.length > 1) {
        this.SpecData = {
          ItemNo: data.ItemNo,
          Suppliers: data.Suppliers,
          SupplierID: row.SupplierID,
          SupplierName: row.SupplierName,
          Index: rowIndex,
          Colors: [],
        }
        if (row.SupplierID) {
          const targetSupplier = data.Suppliers.find(s => s.SupplierID === row.SupplierID)
          if (targetSupplier) {
            this.SpecData.Colors = buildColorSizeData(targetSupplier.detailList)
          }
        }
      } else if (data.Suppliers.length === 1) {
        const supplier = data.Suppliers[0]
        this.SpecData = {
          ItemNo: data.ItemNo,
          Specs: supplier.detailList,
          Suppliers: row.suppliers,
          SupplierID: row.SupplierID,
          SupplierName: row.SupplierName,
          Index: rowIndex,
          Colors: buildColorSizeData(supplier.detailList),
        }
      }
      this.selectedColors = []
      this.activeColor = null
      this.selectedSpecsDisplay = ''
      this.selectPropsDialogVisible = true
    },
    selectSupplier(item) {
      if (item.suppliers.length) {
        item.IsCheck = true
        return
      }
      item.IsCheck = !item.IsCheck
      if (item.IsCheck) {
        this.SpecData.Colors = item.Colors
        this.SpecData.Sizes = item.Sizes
        this.SpecData.Specs = item.detailList
      }
    },
    saveSelectPropsDialog() {
      if (this.selectedColors.length === 0) {
        this.$baseMessageBox('请选择至少一个颜色')
        return
      }
      let hasSelectedSize = false
      this.selectedColors.forEach(color => {
        const selectedSizes = color.Sizes.filter(size => size.IsCheck)
        if (selectedSizes.length > 0) {
          hasSelectedSize = true
        }
      })
      if (!hasSelectedSize) {
        this.$baseMessageBox('请选择至少一个尺码')
        return
      }
      const baseRow = this.tableData[this.SpecData.Index]
      const newRows = []
      this.selectedColors.forEach(color => {
        const selectedSizes = color.Sizes.filter(size => size.IsCheck)
        selectedSizes.forEach(size => {
          const matchSpec = this.SpecData.Specs ? this.SpecData.Specs.find(s => s.Color === color.Value && s.Size === size.Value) : {}
          newRows.push({
            ...baseRow,
            ...matchSpec,
            SpecName: `${color.Value}-${size.Value}`,
            Num: parseInt(baseRow.Num) || 1,
            Payment: (parseInt(baseRow.Num) || 1) * (matchSpec.SettlePrice || 0),
            suppliers: this.SpecData.Suppliers,
            SpecID: matchSpec.SpecID || 0,
            ProductID: matchSpec.ProductID || baseRow.ProductID,
          })
        })
      })
      this.tableData.splice(this.SpecData.Index, 1, ...newRows)
      if (!this.tableData.some(row => !row.ProductID)) {
        this.addEmptyRow()
      }
      this.getStatistics()
      this.selectPropsDialogVisible = false
    },
    createStateFilter(queryString) {
      return state => {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
      }
    },
    getFormData(type) {
      let data = { ...this.form }
      data.Details = []
      let isSettlePriceChange = false
      this.tableData.forEach(item => {
        if (item.ItemNo != '') {
          if (item.Num == '' || parseInt(item.Num) <= 0) {
            data.Error = '货号【' + item.ItemNo + '】的数量要大于0'
          }
          if (item.Price == '' || parseFloat(item.Price) <= 0) {
            data.Error = '货号【' + item.ItemNo + '】的商品价要大于0'
          }
          if (item.SettlePrice == '' || parseFloat(item.SettlePrice) <= 0) {
            data.Error = '货号【' + item.ItemNo + '】的客户价要大于0'
          }
          if (item.ProductID && item.SettlePrice != item.OriginSettlePrice) {
            isSettlePriceChange = true
          }
          data.Details.push(item)
        }
      })
      return { formData: data, isSettlePriceChange: isSettlePriceChange }
    },
    async handleSave(type) {
      if (this.saveLoading) {
        return
      }
      this.saveLoading = true
      try {
        const getData = this.getFormData(type)
        let formData = getData.formData
        if (formData.Error && formData.Error != '') {
          this.$baseMessage(formData.Error, 'error')
          formData.Error = ''
          return
        }
        if (formData.PurchaserName == '') {
          this.$baseMessage('请输入要退货的客户名称', 'error')
          return
        }
        if (formData.Details.length <= 0) {
          this.$baseMessage('请添加要退货的商品信息', 'error')
          return
        }
        formData.PayType = type
        formData.CreateTime += ' ' + this.time
        if (getData.isSettlePriceChange) {
          this.$baseConfirm(`退货商品存在客户价变动，确认继续提交？`, null, async () => {
            await this.doSave(formData)
          })
        } else {
          await this.doSave(formData)
        }
      } finally {
        this.saveLoading = false
      }
    },
    async doSave(formData) {
      const { data } = await submit('/api/stallRefund/addRefundInfo', formData)
      this.$baseMessage('保存成功', 'success')
      if (formData.PayType != null) {
        if (this.printConfig.bill.refundedAutoPrint) {
          await this.$refs.tradePrint1.getPrintInfo('', data, null, null, 1)
          if (this.$refs.tradePrint1.printData.length > 0) {
            await this.$refs.tradePrint1.print('', 5, data)
            this.$('#print-view-refund .paper-bill,#print-view .paper-tag').empty()
          }
        }
        // 打印条码
        if (this.printConfig.bill.autoPrintBarcode) {
          await this.handleBarcodePrint()
        }
        this.$emit('handleAddSuccess', this.printConfig.bill.refundedAutoPrint)
      } else {
        this.$emit('handleAddRefundItems', data)
      }
      this.handleCancel()
    },
    async handleBarcodePrint() {
      try {
        const config = await getBarcodePrintConfig()
        // 直接从 tableData 获取含 Barcode 的数据构建打印列表（Barcode 已由后端返回）
        const specList = []
        this.tableData.forEach(item => {
          if (!item.ProductID || item.ProductID <= 0 || !item.ItemNo) return
          const barcode = item.Barcode || ''
          const color = item.Color || this.parseSpecProp(item, '颜色')
          const size = item.Size || this.parseSpecProp(item, '尺码')
          const count = parseInt(item.Num) || 1
          for (let i = 0; i < count; i++) {
            specList.push({
              Barcode: barcode,
              Sku: barcode,
              ItemNo: item.ItemNo,
              Color: color,
              Size: size,
            })
          }
        })
        if (specList.length === 0) {
          this.$baseMessage('没有可打印条码的商品', 'warning')
          return
        }
        // 保存数据，弹出打印机选择对话框
        this.pendingSpecList = specList
        this.pendingConfig = config
        if (!this.hasInitPrinter) {
          this.initPrinter()
          this.hasInitPrinter = true
        }
        this.selectPrint = true
      } catch (e) {
        console.error('条码打印失败', e)
        this.$baseMessage('条码打印失败：' + (e.message || '未知错误'), 'error')
      }
    },
    // 初始化打印机列表
    initPrinter() {
      setTimeout(() => {
        this.printerList = getPrinters()
        if (this.printerList.length > 0) {
          this.curPrinter = this.printerList[0].label
        }
      }, 1000)
    },
    // 执行条码打印（从打印机选择对话框触发）
    async doPrint() {
      if (!this.curPrinter) {
        this.$baseMessage('请选择打印机', 'warning')
        return
      }
      try {
        await doBarcodePrint.call(this, this.pendingSpecList, this.pendingConfig, this.curPrinter)
        this.selectPrint = false
      } catch (e) {
        console.error('条码打印失败', e)
        this.$baseMessage('条码打印失败：' + (e.message || '未知错误'), 'error')
      }
    },
    parseSpecProp(spec, propName) {
      const specName = spec.SpecName || ''
      if (specName && specName.includes('-')) {
        const idx = specName.indexOf('-')
        if (propName === '颜色') return specName.substring(0, idx) || ''
        if (propName === '尺码') return specName.substring(idx + 1) || ''
      }
      const sizeMatch = specName.match(/[0-9]{1,3}([-][0-9]{1,3})?$/)
      if (sizeMatch) {
        const sizeVal = sizeMatch[0]
        const colorVal = specName.substring(0, specName.length - sizeVal.length).replace(/[-_\s]+$/, '')
        if (propName === '尺码') return sizeVal
        if (propName === '颜色') return colorVal || specName
      }
      if (propName === '颜色') return specName
      return ''
    },
    handleCancel() {
      this.tableData = []
      this.purchaserProducts = {}
      this.searchItems = []
      this.searchPurchases = []
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
#print-view-refund {
  position: fixed;
  left: -1000px;
}

.dialog-footer {
  position: relative;

  .checkbox-block {
    position: absolute;
    left: 28px;
    top: 8px;
  }

  .el-button {
    width: 100px !important;
    padding: 10px 10px !important;
  }
}

.div_prop_item {
  display: inline-block;
}

.div_prop_value {
  display: inline-block;
  vertical-align: top;
  margin-bottom: 9px;
  margin-right: 4.5px;
  margin-left: 4.5px;
  padding: 2px;
  font-size: 14px;
  line-height: 14px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  color: #333;
  text-overflow: ellipsis;
  padding: 0 8px;
  white-space: nowrap;
  overflow: hidden;
  line-height: 30px;
  vertical-align: middle;
  background-color: rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid transparent;
  text-align: center;
  position: relative;
}

.div_prop_value.current {
  color: #409eff;
  border-color: #409eff;
  background-color: #fff7f3;
}

.div_prop_value.disabled {
  cursor: not-allowed;
  color: #ccc;
  background-color: rgba(0, 0, 0, 0.06);
}

.time {
  color: #f56c6c;
  font-size: 25px;
}

.editForm {
  .el-input {
    max-width: 140px;
  }

  ::v-deep {
    .el-form-item__label {
      padding-right: 0px;
    }
  }

  .el-radio {
    margin-left: 10px;
    margin-right: 0px;
  }
}

.prop-list {
  display: inline-block;
  margin-left: 10px;
}

::v-deep {
  .warn-tip .el-input__inner {
    border-color: red !important;
  }
}

.supplier-display-container {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.supplier-label {
  display: inline-block;
  width: 60px;
  font-size: 14px;
  color: #666;
  text-align: right;
  margin-right: 12px;
}

.supplier-info {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  max-width: calc(100% - 72px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-icon-setting {
  font-size: 18px;
  color: #409eff;
  cursor: pointer;
  vertical-align: middle;
  margin-right: 8px;
}
</style>
